import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useApiClient } from "../../../apiClient";
import { AddAvailabilitiesInputDto } from "../../../models/court/dto/add-availabilities.dto";
import { CourtAvailabilityDto } from "../../../models/court/dto/court-availability.dto";

/**
 * `onError` receives the `ApiError`, whose `message` is the API's own 400 text
 * ("Invalid availability pricing capacity \"30\"…", "Duplicate availability
 * pricing for sport…"). It took no arguments before, so the reason a save was
 * refused could not reach the operator at all.
 */
export const useAddAvailabilities = (onSuccess?: (data: CourtAvailabilityDto[]) => void, onError?: (error: unknown) => void) => {
    const client = useApiClient();
    const queryClient = useQueryClient();
    return useMutation({
        mutationKey: ['addAvailabilities'],
        mutationFn: (input: AddAvailabilitiesInputDto) => client.fetchApi<CourtAvailabilityDto[], AddAvailabilitiesInputDto>({ method: 'POST', endpoint: `courts/${input.courtId}/add-availabilities`, body: input }),
        onSuccess: (data) => {
            queryClient.invalidateQueries(['courtCalendar', data[0].courtId]);
            if (onSuccess)
                onSuccess(data)
        },
        onError
    });
}